/**
 * Title-case each word for greeting labels (fixes stored names like "front Desk User").
 */
export function formatDisplayName(name, fallback = 'Guest') {
  if (name == null || name === '') return fallback;
  if (typeof name !== 'string') return fallback;

  return name
    .trim()
    .split(/\s+/)
    .map((word) => {
      if (!word) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
